import './assets/plugins/ngExcel/ngExcel';
import 'ng-sortable';
import 'chart.js';
import 'angular-chart.js'

import './app'
import './routes';
import './prototype';
import './directives';
import './constants';


import './components/general/seguridadService'
import './components/general/authInterceptorService'
import './components/general/usuarioInfo-service'
import './components/general/portal-service'
import './components/general/unidad-service'
import './components/general/domicilio-service'
import './components/general/tramite-service'
import './components/general/agendasBloqueadasService'
import './components/general/utilsService'
import './components/general/calendario-service'
import './components/general/menuService'
import './components/general/signalrDotNetCoreService'
import './components/general/derivacion-service'
import './components/general/estadisticaService'
import './components/general/generalService'
import './components/general/personaJuridicaService'


import './shared/header/headerComponent'
import './shared/sidebar/sidebarComponent'
import './shared/header/headerCiudadanoComponent'
import './shared/selectCentroAtencion/selectCentroAtencion'
import './shared/header/headerLlamadorComponent'
import './shared/notificaciones/mailNotificacionesComponent'
import './shared/calendarioExterno/calendarioExternoComponent'
import './shared/calendarioExterno/headerExternoComponent'
import './shared/calendarioExterno/confirmacionExternaComponent'
import './shared/integracionMiDocta/miDoctaModoService';
import './shared/integracionMiDocta/integracionMiDoctaApiService';
import './shared/integracionMiDocta/miDoctaIframeComponent';


import './components/layout/admin/adminComponent'
import './components/layout/ciudadano/ciudadanoComponent'
import './components/layout/llamador/llamadorComponent'
import './components/layout/recepcion/recepcionComponent'
import './components/layout/encuestas/encuestaComponent'
import './components/layout/encuestas/encuestas-service'
import './components/layout/errores/errorsComponent'
import './components/layout/sidebar/sidebarComponent'


import './components/layout/errores/errorsService'


import './components/asistencia/asistencia_consultaTurnoComponent'
import './components/asistencia/asistencia_anunciarTurnoComponent'
import './components/asistencia/asistencia_darTurnoComponent'
import './components/asistencia/asistencia_PersonaComponent'
import './components/asistencia/CalendarioComponent'
import './components/asistencia/ConfirmacionComponent'
import './components/asistencia/asistencia_TelefonicoComponent'


import './components/centrosAtencion/centrosAtencionComponent'
import './components/centrosAtencion/centrosAtencionAltaComponent'
import './components/centrosAtencion/centrosAtencionModificarComponent'
import './components/centrosAtencion/centrosAtencionService'


import './components/trs/trs-service'
import './components/trs/trsTramiteComponent'
import './components/trs/trsTurnoViewComponent'

import './components/grupos/grupos-usuarios/grupoUsuariosComponent'
import './components/grupos/grupos-usuarios/grupoUsuariosAltaComponent'
import './components/grupos/grupos-usuarios/grupoUsuariosModificarComponent'
import './components/grupos/grupos-usuarios/grupoUsuariosService'

import './components/grupos/gruposComponent'
import './components/grupos/gruposAltaComponent'
import './components/grupos/gruposModificarComponent'
import './components/grupos/gruposService'


import './components/reportes/reportesComponent'
import './components/reportes/reportesEncuestasComponent'
import './components/reportes/reportesService'


import './components/motivos/motivosComponent'
import './components/motivos/motivosAltaComponent'
import './components/motivos/motivosModificarComponent'
import './components/motivos/motivosService'

import './components/preguntas/preguntasComponent'
import './components/preguntas/preguntasDetalleComponent'
import './components/preguntas/preguntasService'


import './components/puestos/puestosComponent'
import './components/puestos/puestosAltaComponent'
import './components/puestos/puestosModificarComponent'
import './components/puestos/puestosService'


import './components/usuarios/usuariosComponent'
import './components/usuarios/usuariosAltaComponent'
import './components/usuarios/usuariosModificarComponent'
import './components/usuarios/usuariosService'


import './components/supervision/atencionEnCursoComponent'
import './components/supervision/estadosPuestosComponent'
import './components/supervision/Bloqueo_Atencion/bloqueoAtencionComponent'
import './components/supervision/Bloqueo_Atencion/altaBloqueoComponent'
import './components/supervision/Bloqueo_Atencion/bloqueoCalendarioService'
import './components/supervision/cambioEstadoFinalComponent'
import './components/supervision/estadosDeSalonComponent'
import './components/supervision/reagendarTurnoComponent'
import './components/supervision/encuestas/encuestasComponent'
import './components/supervision/encuestas/encuestasHistorialComponent'
import './components/supervision/encuestas/encuestasWizardComponent'
import './components/supervision/encuestas/encuestasPreguntasComponent'
import './components/supervision/encuestas/encuestasOpcionesComponent'
import './components/supervision/encuestas/encuestasService'


import './components/tramites/tramitesComponent'
import './components/tramites/tramitesAltaComponent'
import './components/tramites/tramitesModificarComponent'
import './components/tramites/tramitesService'


import './components/agenda/agendaConsultaComponent'
import './components/agenda/agenda_InicioComponent'
import './components/agenda/agenda_Paso1Component'
import './components/agenda/agenda_Paso2Component'
import './components/agenda/agenda_Paso3Component'
import './components/agenda/agenda_Paso4Component'
import './components/agenda/agenda_Paso5Component'
import './components/agenda/agenda_FinalizarComponent'
import './components/agenda/agenda_HistorialComponent'
import './components/agenda/agendaService'


import './components/turnos/turnos_listaComponent'
import './components/turnos/turnosFiltrosComponent'
import './components/turnos/turnoComentarioComponent'
import './components/turnos/turnoDetalleComponent'
import './components/turnos/turnoHistorialComponent'
import './components/turnos/turnoComprobanteComponent'
import './components/asistencia/certificadoComponent'
import './components/turnos/turnoListadoImprimirComponent'
import './components/turnos/turnoOrderDeLlegada_ComprobanteComponent'
import './components/turnos/turnosService'
import './components/turnos/turnoReagendadoComponent'


import './components/roles/rolesComponent'
import './components/roles/rolesAltaComponent'
import './components/roles/rolesModificarComponent'
import './components/roles/rolesService'


import './components/turnos/turnosOnline/ciudadanohomeComponent'
import './components/turnos/turnosOnline/atencionTelefonicaComponent'
import './components/turnos/turnosOnline/misTurnosComponent'
import './components/turnos/turnosOnline/turnoOnlineCentroAtencionComponent'
import './components/turnos/turnosOnline/turnoOnlineCalendarioComponent'
import './components/turnos/turnosOnline/turnoOnlineTramiteComponent'
import './components/turnos/turnosOnline/turnoOnlineTramiteAlternativaComponente'
import './components/turnos/turnosOnline/turnoOnlineConfirmacionComponent'
import './components/turnos/turnosOnline/turnoOnlinePortalComponent'


import './components/turnos/tasasRetributivas/tasasDetalleComponent'
import './components/turnos/tasasRetributivas/tasasHistoricoComponent'


import './components/recepcion/recepcionInicioComponent'
import './components/recepcion/recepcion_DNIAnunciarComponent'
import './components/recepcion/recepcion_DNISacarComponent'
import './components/recepcion/recepcion_turnosAnunciarComponent'
import './components/recepcion/recepcion_turnosSacarComponent'


import './components/loginCentros/centros_loginComponent'


import './components/llamador/listadoLlamadorComponent'
import './components/llamador/llamadorConfiguracionComponent'
import './components/llamador/llamadorService'


import './components/atencion/turnosHistoricoComponent'
import './components/atencion/detalleAtencionTurnoComponent'
import './components/atencion/atencionComponent'
import './components/atencion/atencionListadoComponent'
import './components/atencion/atencionFilaListadoComponent'
import './components/atencion/sidebarAtencionListadoComponent'
import './components/atencion/sidebarAtencionSeleccionComponent'
import './components/atencion/sidebarAtencionComponent'

import './components/appExterna/appExternaComponent'
import './components/appExterna/appExternaViewComponent'
import './components/appExterna/appExterna-service'


import './components/monitor/monitorComponent'
import './components/monitor/monitorService'

import './components/login/loginComponent'
import './components/login/loginService'

import './components/cancelarTurno/cancelarTurnoComponent'

require('./assets/css/vendor.css');
require('./assets/css/turnero.css');
require('./assets/css/tramites-midocta.css');
require('./assets/css/app.css');
require('./assets/css/MaterialIcons.css');
require('./assets/css/md-data-table.min.css');
require('./assets/css/ng-animation.css');
require('./assets/css/ngCanvasGauge.css');
require('./assets/css/font-awesome/css/font-awesome.min.css');
//require('./assets/plugins/angularjs/plugins/angularmaterial/angular-material.css');
require('./assets/plugins/sweetalert2/sweetalert2.min.css');
require('./assets/plugins/angularjs/plugins/ui-select/dist/select.css');


// WEBPACK FOOTER //
// ./app/index.js